// actionTypes.js
export const SET_VALUE_RESERVATION_EN_COURS = "SET_VALUE_RESERVATION_EN_COURS";
export const SET_CURRENT_PAGE_RESERVATION_EN_COURS =
  "SET_CURRENT_PAGE_RESERVATION_EN_COURS";
export const SET_ORDER_RESERVATION_EN_COURS = "SET_ORDER_RESERVATION_EN_COURS";
export const SET_SORT_FIELD_RESERVATION_EN_COURS =
  "SET_SORT_FIELD_RESERVATION_EN_COURS";
export const SET_PAGE_SIZE_RESERVATION_EN_COURS =
  "SET_PAGE_SIZE_RESERVATION_EN_COURS";
export const SET_CUSTOM_FILTERS_RESERVATION_EN_COURS =
  "SET_CUSTOM_FILTERS_RESERVATION_EN_COURS";
export const SET_SORTING_RESERVATION_EN_COURS =
  "SET_SORTING_RESERVATION_EN_COURS";
export const SET_ACTIVE_TAB_RESERVATION_EN_COURS =
  "SET_ACTIVE_TAB_RESERVATION_EN_COURS";
export const SET_QUERY_RESERVATION_EN_COURS = "SET_QUERY_RESERVATION_EN_COURS";
export const SET_ACTIF_RESERVATION_EN_COURS = "SET_ACTIF_RESERVATION_EN_COURS";
export const SET_SELECTED_OPTION_FILTERS_RESERVATION_EN_COURS =
  "SET_SELECTED_OPTION_FILTERS_RESERVATION_EN_COURS";
export const SET_SELECTED_OPTION_ID_RESERVATION_EN_COURS =
  "SET_SELECTED_OPTION_ID_RESERVATION_EN_COURS";
export const SET_COLUMN_RESERVATION_EN_COURS =
  "SET_COLUMN_RESERVATION_EN_COURS";
